import { useState } from "react";
import SectionReveal from "@/components/SectionReveal";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "Do I need a visa to visit China?",
    a: "UAE passport holders enter China visa-free for up to 30 days (since 2018). GCC residents from Bahrain, Kuwait, Oman and Saudi Arabia also enjoy 30-day visa-free entry as of June 2025. 55 countries (incl. UK, EU, US) qualify for the 240-hour visa-free transit. For longer stays we file Tourist (L), Business (M) or Student (X) visas via the official Visa Application Center in Dubai."
  },
  {
    q: "Is China safe for international travelers?",
    a: "Yes — China consistently ranks among the safest large countries in the world for travelers. Violent crime is extremely rare. Our guides additionally vet hotels, neighborhoods, dining options (incl. halal, vegetarian, women-safe). Our 24/7 WhatsApp concierge is one tap away during your trip."
  },
  {
    q: "Can I use international credit cards?",
    a: "Since 2024, Alipay and WeChat Pay accept foreign Visa, Mastercard and Amex — and these two apps work everywhere from luxury hotels to street food. We help you set them up before you land. Cash is rarely needed."
  },
  {
    q: "Do you provide English-speaking assistance?",
    a: "Every guide we deploy speaks fluent English. We also offer Arabic, Mandarin, French, Spanish, German and Russian-speaking guides on request. WhatsApp concierge is available 24/7 in your language."
  },
  {
    q: "Can you customize my itinerary?",
    a: "Yes — every trip is hand-built. Start with our AI concierge Mei for a draft (30 seconds), then a human curator refines it with you over WhatsApp. Pace, hotels, dining, interests — all flexible."
  },
  {
    q: "Can you arrange business meetings and factory visits?",
    a: "Absolutely. We organize end-to-end B2B trips: pre-vetted supplier matching, factory tours, bilingual interpreters, contract liaison, Canton Fair / CIIE / China Import Expo coverage. Decades of relationships across the Pearl River and Yangtze deltas."
  },
  {
    q: "Do you organize educational programs and study tours?",
    a: "Yes — Chinese language immersion (HSK preparation) and cultural discovery programs in partnership with Tangshan Maritime Vocational College and Jidong cultural institutions. Formats from 7 days to full summer/winter camps, for students, schools and delegations."
  },
];

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="bg-[#EAE6DF] py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <SectionReveal>
          <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#C62828] font-semibold mb-4">
            ✦ Frequently Asked Questions
          </p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#121212] leading-[1.05]">
            Everything you need to know.
          </h2>
        </SectionReveal>

        <div className="mt-12 divide-y divide-black/10 border-t border-b border-black/10">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`}>
                <button
                  data-testid={`faq-toggle-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-start justify-between gap-4 py-6 text-left"
                >
                  <span className="font-heading text-lg md:text-xl text-[#121212]">{f.q}</span>
                  <ChevronDown
                    size={20}
                    className={`text-[#4A4A4A] flex-shrink-0 mt-1 transition-transform duration-300 ${
                      isOpen ? "rotate-180 text-[#C62828]" : ""
                    }`}
                  />
                </button>
                {isOpen && (
                  <p
                    data-testid={`faq-answer-${i}`}
                    className="pb-6 pr-8 text-[#4A4A4A] leading-relaxed"
                  >
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
